import type {
  CancelReplanMode,
  CancelReplanStepId,
  CancelReplanWorkflowOutputs,
} from "../../../_logic/cancel-replan-contract"

export type CancelReplanStepOrderOptions = {
  includeCancelAnnouncementsStep?: boolean
}

export const stepOrderForCancelReplanMode = (
  mode: CancelReplanMode,
  options: CancelReplanStepOrderOptions = {},
): CancelReplanStepId[] => {
  const includeCancelAnnouncementsStep = options.includeCancelAnnouncementsStep ?? true

  if (mode === "createAppointments") return ["plan", "announce", "summary"]

  if (mode === "createAnnouncementPlans") {
    return includeCancelAnnouncementsStep
      ? ["cancelAnnouncements", "announce", "summary"]
      : ["announce", "summary"]
  }

  if (mode === "cancelAnnouncementPlans") return ["cancelAnnouncements", "summary"]

  return ["cancel", "plan", "announce", "summary"]
}

const baseEntry = ({
  id,
  label,
  done,
}: {
  id: CancelReplanStepId
  label: string
  done?: boolean
}) => ({
  id,
  label,
  description: "",
  hideDefaultAction: true,
  progressStatus: done ? "done" : undefined,
})

export const buildCancelReplanProgressEntries = (
  outputs: CancelReplanWorkflowOutputs,
  mode: CancelReplanMode,
  options: CancelReplanStepOrderOptions = {},
) =>
  stepOrderForCancelReplanMode(mode, options).map((step) => {
    if (step === "cancel")
      return baseEntry({ id: step, label: "Termine stornieren", done: Boolean(outputs.cancel) })

    if (step === "plan") {
      return baseEntry({
        id: step,
        label: mode === "rescheduleAppointments" ? "Neu planen" : "Termine planen",
        done: Boolean(outputs.planning?.committed),
      })
    }

    if (step === "cancelAnnouncements") {
      return baseEntry({
        id: step,
        label:
          mode === "cancelAnnouncementPlans" ? "Ankündigungsplan beenden" : "Bestehende beenden",
        done: Boolean(outputs.cancelAnnouncements),
      })
    }

    if (step === "announce") {
      return baseEntry({
        id: step,
        label:
          mode === "rescheduleAppointments" ? "Kunden informieren" : "Ankündigungsplan anlegen",
        done: Boolean(outputs.announce),
      })
    }

    return baseEntry({ id: step, label: "Ergebnis", done: Boolean(outputs.summary) })
  })
